// ** Third Party Imports
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

interface ActionButtonProps {
	size: 'normal' | 'small'
	color: 'primary' | 'secondary' | 'success' | 'error' | 'warning'
	variant: 'primary' | 'secondary' | 'text'
	disabled: boolean
	$fullWidth: boolean
}

const actionButtonStyles = css<ActionButtonProps>`
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	border: none;
	outline: none;
	border-radius: 9999px;
	text-transform: uppercase;
	transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,
		transform 0.1s ease;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

	&:active {
		transform: translateY(1px);
	}

	& svg {
		width: 1.25rem;
		height: 1.25rem;
		flex-shrink: 0;

		path {
			stroke: currentColor;
		}
	}

	${({ size }) =>
		`width: ${size === 'small' ? '40px' : '48px'}; height: ${size === 'small' ? '40px' : '48px'};`}

	${({ size }) => `font-size: ${size === 'small' ? '0.8rem' : '0.95rem'};`}

	${({ color, variant, theme }) =>
		variant === 'primary' &&
		`
		color: ${color === 'secondary' ? theme.pallette.text.black75 : '#fff'};
		background: ${theme.pallette[color].main};
		border: 1px solid transparent;

		&:hover {
			background: ${theme.pallette[color].main};
			color: ${color === 'secondary' ? theme.pallette.text.black75 : '#fff'};
		}
	`}

	${({ color, variant, theme }) =>
		variant === 'secondary' &&
		`
		color: ${
			color === 'secondary'
				? theme.pallette.text.black75
				: theme.pallette[color].main
		};
		background: transparent;
		border: 1px solid ${theme.pallette[color].main};
		box-shadow: none;

		&:hover {
			color: #fff;
			background: ${theme.pallette[color].main};
			border-color: ${theme.pallette[color].main};
		}
	`}

	${({ color, variant, theme }) =>
		variant === 'text' &&
		`
		color: ${theme.pallette[color].main};
		background: transparent;
		border: none;
		box-shadow: none;

		&:hover {
			color: ${theme.pallette[color].main};
			background: ${theme.pallette[color].main}1a;
		}
	`}

	${({ $fullWidth }) =>
		$fullWidth &&
		`
		width: 100%;
	`}

	${({ theme, disabled }) =>
		disabled &&
		`
		background: transparent !important;
		border: none !important;
		box-shadow: none;
		pointer-events: none !important;
	`}
`

export const StyledActionButton = styled.button<ActionButtonProps>`
	${actionButtonStyles}
`

export const StyledActionLink = styled(Link)<ActionButtonProps>`
	${actionButtonStyles}
	text-decoration: none;
`

export const StyledActionAnchor = styled.a<ActionButtonProps>`
	${actionButtonStyles}
	text-decoration: none;
`

